export enum Breakpoint {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
}

export enum Category {
  HEAD = 'HEAD',
  HAIR = 'HAIR',
  EYES = 'EYES',
  NOSE = 'NOSE',
  MOUTH = 'MOUTH',
  EARS = 'EARS',
  FACIAL_HAIR = 'FACIAL_HAIR',
  ACCESSORIES = 'ACCESSORIES',
  ACCESSORIES_EYEWEAR = 'EYEWEAR',
  ACCESSORIES_HEADGEAR = 'HEADGEAR',
  ACCESSORIES_FANFETTI = 'FANFETTI',
  ACHIEVEMENTS = 'ACHIEVEMENTS',
  BACKGROUND = 'BACKGROUND',
  LOGO = 'LOGO',
}

export const ACCESSORY_CATEGORY_GROUP = [
  Category.ACCESSORIES,
  Category.ACCESSORIES_EYEWEAR,
  Category.ACCESSORIES_HEADGEAR,
  Category.ACCESSORIES_FANFETTI,
];

export const ACCESSORY_SUBCATEGORY_GROUP = [
  Category.ACCESSORIES_EYEWEAR,
  Category.ACCESSORIES_HEADGEAR,
  Category.ACCESSORIES_FANFETTI,
];

export const BACKGROUND_CATEGORY_GROUP = [Category.BACKGROUND, Category.LOGO];

export const CATEGORY_PICKER_IGNORE_GROUP = [
  Category.ACHIEVEMENTS,
  Category.ACCESSORIES_EYEWEAR,
  Category.ACCESSORIES_HEADGEAR,
  Category.ACCESSORIES_FANFETTI,
  Category.LOGO,
];
